/* PATCH v3.7 - 2026-07-07 */
(function () {
'use strict';

/* 1. CSS */
(function () {
  var s = document.createElement('style');
  s.id = 'pe-p2';
  s.textContent =
    '.mn-link{font-size:17px!important;font-weight:600!important}' +
    '.mn-foot-row .mn-btn-new,.mn-foot-row .mn-btn-sale{padding:9px 20px!important;font-size:10.5px!important;letter-spacing:.13em!important;border-radius:0!important;opacity:1!important;border:none!important;text-transform:uppercase!important;font-weight:700!important;flex:0 0 auto!important;}' +
    '.mn-foot-row .mn-btn-new{background:#000!important;color:#fff!important;box-shadow:none!important;}' +
    '.mn-foot-row .mn-btn-sale{background:#fff!important;color:#000!important;box-shadow:none!important;border:1px solid #000!important;}' +
    '.mn-foot-row{gap:10px!important;padding:8px 18px 12px!important;justify-content:flex-start!important;}' +
    '.mn-marquee{border-top:1px solid #E6E6E3!important;margin-top:4px!important;padding-bottom:env(safe-area-inset-bottom,0)!important}' +
    '.smp-feature-label{display:none!important}' +
    '.smp-feature-inner{display:flex!important;align-items:flex-end!important;justify-content:flex-end!important;padding:10px!important}' +
    '.smp-feature-cta{background:rgba(255,255,255,.36)!important;padding:5px 11px!important;font-size:9px!important;box-shadow:0 2px 8px -3px rgba(0,0,0,.22)!important;backdrop-filter:blur(4px)!important;}' +
    '.smp-feature:hover .smp-feature-cta{background:rgba(255,255,255,.58)!important;color:#111!important;}' +
    '.mn-feat-card-title{display:none!important}' +
    '.mn-feat-card-inner{display:flex!important;align-items:flex-end!important;justify-content:flex-end!important;padding:8px!important}' +
    '.mn-feat-card-cta svg{display:none!important}' +
    '.pc-badge.new{bottom:8px!important;left:8px!important;top:auto!important;right:auto!important;background:rgba(10,10,10,0.55)!important;border-radius:0!important}' +
    '.mn-foot-link{font-size:15px!important;font-weight:500!important}' +
    /* v42 auditoria C: o aviso "Esgotado" da ficha volta a aparecer (o .pc-badge.sold-out continua escondido porque o cartao ja mostra o .pc-sold-out-pill) */
    '.mn-sub-group{margin-left:24px!important;border-left:1px solid #E6E6E3!important}' +
    '.mn-sub-btn{padding-left:20px!important}' +
    '.pc-badge.sold-out{display:none!important}' +
    '.nh-ed-grid{margin-top:56px!important}' +
    /* Product cards: cover + top = no bars */
    '.pc-img-main,.pc-img-alt{object-fit:cover!important;object-position:top center!important;}' +
    /* You might also like thumbnails: show face from top */
    '.gs-also-like-img img{object-fit:cover!important;object-position:top center!important;}' +
    /* Cart PAGE (/cart) item images: show face from top */
    '.cp-item-img img{object-fit:cover!important;object-position:top center!important;}' +
    /* Cart DRAWER (mini-cart) item images: show face from top */
    '.cd-item-img img{object-fit:cover!important;object-position:top center!important;width:100%!important;height:100%!important;}' +
    /* Product page gallery - DESKTOP: remove fixed 4/5 ratio so full photo shows */
    '@media(min-width:769px){.gs-img-item{aspect-ratio:unset!important;overflow:visible!important;}.gs-img-item img{width:100%!important;height:auto!important;object-fit:unset!important;object-position:unset!important;display:block!important;}}' +
    /* Product page gallery - MOBILE: use 2/3 ratio (matches portrait fashion photos) */
    '@media(max-width:768px){.gs-img-item{aspect-ratio:2/3!important;overflow:hidden!important;}.gs-img-item img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:top center!important;display:block!important;}}' +
    /* ── Description typography v3.7 ── */
    /* Base: warmer ink, readable size, generous line-height */
    '.gs-accord-body{color:#4A4A45!important;font-size:14px!important;line-height:1.85!important;}' +
    /* Paragraphs: breathing room below */
    '.gs-accord-body p{font-size:14px!important;line-height:1.85!important;color:#4A4A45!important;margin:0 0 12px!important;}' +
    /* H1-H3: editorial serif, italic, dark ink */
    '.gs-accord-body h1,.gs-accord-body h2,.gs-accord-body h3{font-family:inherit!important;font-style:normal!important;color:#111111!important;font-weight:600!important;}' +
    '.gs-accord-body h1{font-size:22px!important;margin:16px 0 8px!important;line-height:1.3!important;}' +
    '.gs-accord-body h2{font-size:19px!important;margin:14px 0 7px!important;line-height:1.3!important;}' +
    '.gs-accord-body h3{font-size:16px!important;margin:12px 0 6px!important;line-height:1.35!important;}' +
    /* H4-H6: tiny uppercase label style */
    '.gs-accord-body h4,.gs-accord-body h5,.gs-accord-body h6{font-family:Inter,sans-serif!important;font-size:10px!important;letter-spacing:.12em!important;text-transform:uppercase!important;color:#6B6B65!important;font-weight:600!important;font-style:normal!important;margin:10px 0 4px!important;line-height:1.4!important;}' +
    /* Lists: clean, no browser bullets */
    '.gs-accord-body ul,.gs-accord-body ol{list-style:none!important;padding:0!important;margin:0 0 12px!important;}' +
    '.gs-accord-body li{position:relative!important;padding-left:16px!important;margin-bottom:5px!important;font-size:14px!important;line-height:1.7!important;color:#4A4A45!important;}' +
    /* UL: forest-green dot */
    '.gs-accord-body ul>li::before{content:""!important;position:absolute!important;left:0!important;top:9px!important;width:5px!important;height:5px!important;border-radius:50%!important;background:#111!important;display:block!important;}' +
    /* OL: muted numbered counter */
    '.gs-accord-body ol{counter-reset:pe-desc!important;}' +
    '.gs-accord-body ol>li{counter-increment:pe-desc!important;}' +
    '.gs-accord-body ol>li::before{content:counter(pe-desc) "."!important;position:absolute!important;left:0!important;top:0!important;font-size:11px!important;color:#6B6B65!important;font-weight:600!important;}' +
    /* Strong / bold */
    '.gs-accord-body strong,.gs-accord-body b{font-weight:600!important;color:#111111!important;}' +
    /* Links */
    '.gs-accord-body a{color:#111!important;text-decoration:underline!important;text-underline-offset:3px!important;}' +
    /* Horizontal rule */
    '.gs-accord-body hr{border:none!important;border-top:1px solid #E6E6E3!important;margin:16px 0!important;}' +
    /* Tables */
    '.gs-accord-body table{width:100%!important;border-collapse:collapse!important;margin:0 0 14px!important;font-size:13px!important;}' +
    '.gs-accord-body th{text-align:left!important;font-size:10px!important;letter-spacing:.1em!important;text-transform:uppercase!important;color:#6B6B65!important;font-weight:600!important;padding:6px 0!important;border-bottom:1px solid #E6E6E3!important;}' +
    '.gs-accord-body td{padding:7px 0!important;border-bottom:1px solid #EFEFED!important;color:#4A4A45!important;}' +
    /* Blockquote */
    '.gs-accord-body blockquote{border-left:2px solid #111!important;margin:14px 0!important;padding:8px 0 8px 16px!important;font-style:italic!important;color:#4A4A45!important;}';
  document.head.appendChild(s);
})();

/* 2. Remove fixed black bar if it exists */
(function () {
  function removeBar() {
    var el = document.getElementById('pe-fship');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }
  removeBar();
  document.addEventListener('DOMContentLoaded', removeBar);
})();

/* 3. Desktop: add-to-cart redirect to /cart page
   v42 auditoria A: desligado - ao adicionar abre a cesta lateral, como no telemovel.
   Para voltar a ir para a pagina /cart basta definir window.PE_ATC_TO_CART_PAGE = true antes deste ficheiro. */
(function () {
  if (window.PE_ATC_TO_CART_PAGE !== true) return;
  var _f = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : ((resource || {}).url || '');
    var pr = _f.apply(this, arguments);
    if (url && url.indexOf('/cart/add') !== -1 && window.innerWidth >= 768) {
      return pr.then(function (r) {
        if (r && r.ok) setTimeout(function () { window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart' /* v30: com o prefixo da lingua */; }, 80);
        return r;
      });
    }
    return pr;
  };
  ['cart:open', 'cart-open', 'openCart', 'cart:toggle'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      if (window.innerWidth >= 768) {
        e.stopImmediatePropagation();
        window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart' /* v30: com o prefixo da lingua */;
      }
    }, true);
  });
})();

/* 4. Mobile nav: reorder */
document.addEventListener('DOMContentLoaded', function () {
  var nav = document.getElementById('mobileNav');
  if (!nav) return;
  var marquee   = nav.querySelector('.mn-marquee');
  var footRow   = nav.querySelector('.mn-foot-row');
  var footLinks = nav.querySelector('.mn-foot-links');
  if (footLinks) nav.appendChild(footLinks);
  if (footRow)   nav.appendChild(footRow);
  if (marquee)   nav.appendChild(marquee);
});

/* 5. v2.7 — Exact vendor filter with MutationObserver */
(function () {
  var m = window.location.search.match(/[?&]vendor=([^&]+)/);
  if (!m) return;
  var vnd = ''; try { vnd = decodeURIComponent(m[1]).trim().toLowerCase(); } catch (e) { return; }
  if (!vnd) return;
  function applyVendorFilter() {
    var grid = document.getElementById('collGrid');
    if (!grid) return;
    grid.querySelectorAll('.product-card[data-vendor]').forEach(function (card) {
      var cv = (card.dataset.vendor || '').trim().toLowerCase();
      card.style.display = (cv !== vnd) ? 'none' : '';
    });
  }
  function setup() {
    applyVendorFilter();
    var grid = document.getElementById('collGrid');
    if (grid) {
      var obs = new MutationObserver(function () { applyVendorFilter(); });
      obs.observe(grid, { childList: true });
    }
    var lmBtn = document.getElementById('lmBtn');
    if (lmBtn) { lmBtn.addEventListener('click', function () { setTimeout(applyVendorFilter, 800); }); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else { setup(); }
})();

})(); /* end PATCH v3.7 */
